import { getCompositeSubmissionId } from '../../../Helpers/originId';
import { ClientApiRequestError } from './clientApiError.helpers';

const OUTCOME_PATH = '/proxy/outreach-api-integrations/api/v1/chameleonWebhook';

// eslint-disable-next-line import/prefer-default-export
export const postClientApiJourneyOutcome = async ({
  submissionId,
  token,
  outcome,
  outcomeDetail,
  referenceId,
  location,
  slot,
  answers,
}) => {
  const url = `${process.env.NEXT_PUBLIC_CHAMELEON_GATEWAY_BASE_URL}${OUTCOME_PATH}`;

  const response = await fetch(url, {
    method: 'POST',
    keepalive: true,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      submissionId: getCompositeSubmissionId(submissionId),
      outcome,
      outcomeDetail,
      ...(referenceId && { referenceId }),
      location,
      slot,
      ...(answers && Object.keys(answers).length > 0 && { answers }),
    }),
  });

  if (!response.ok) {
    throw new ClientApiRequestError(
      `Journey outcome failed with status ${response.status}`,
      response.status
    );
  }
};
